import React, { useEffect, useState } from "react";
import { ContentWrapper } from "../../../components/styled/styled";
import {
  BackButton,
  Box,
  ButtonStyled,
  LabelStyled,
  SpanStyled,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FormRadio from "../../../components/common/radioButtons/FormRadio";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { ManageHqBranchesWrapper } from "./styled";
import { useForm } from "react-hook-form";
import AddSingleUser from "../../../components/common/modals/singleUserModal/AddSingleUser";
import { Plus } from "../../../components/styled/AllImages";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { Form } from "react-bootstrap";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import ValidationErrorText from "../../../components/common/inputFields/ValidationErrorText";
import { useUser } from "../../../context/userContext";
import HQBranchesApi from "../../../services/api/hqBranchesApi";
import { toast } from "react-toastify";
import { LazyLoadDropdown } from "../../../components/common/dropdowns/LazyLoadDropdown";
import { useSelector } from "react-redux";

const AddHQBranch = () => {
  const { usersList } = useSelector((state) => state.helper);
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const navigate = useNavigate();

  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  // const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [citiesLoading, setCitiesLoading] = useState(false);
  const [contactPerson, setContactPerson] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const usersListWithAdminDir = user &&
    user?.user_type_id === 2 && [
      {
        name: `${user?.name} (${t("me")})`,
        id: user?.id,
        subLabel:
          user?.department &&
          user?.office_location ? `${
            language === "en"
              ? user?.department?.name_en
              : user?.department?.name_ar
          } (${
            language === "en"
              ? user?.office_location?.name_en
              : user?.office_location?.name_ar
          })` : null,
      },
      ...usersList,
    ];
    

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleValidation = () => {
    let newErrors = {};
    // if (!contactPerson) {
    //   newErrors.contactPerson = "fieldRequired";
    // }
    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearch = (searchQuery) => {
    getCitiesList(currentPage, searchQuery);
  };

  const handleLoadMore = () => {
    getCitiesList(currentPage + 1);
  };

  const getCitiesList = async (pageNum = 1, searchQuery) => {
    if (citiesLoading) return;
    try {
      setCitiesLoading(true);
      const response = await HQBranchesApi.getCitiesFromCountry(
        user.country_id,
        pageNum,
        searchQuery
      );
      if (response.code === 200) {
        const citiesData = response?.data?.data.map((city) => ({
          label: language === "en" ? city.en_name : city.ar_name,
          value: city.id,
        }));
        if (searchQuery) {
          setFilteredCities(citiesData);
        } else {
          setCities((prevCities) => [...prevCities, ...citiesData]);
        }
        setHasMore(!!response.data.next_page_url);
        setCurrentPage(pageNum);
      }
    } catch (error) {
    } finally {
      setCitiesLoading(false);
    }
  };

  useEffect(() => {
    getCitiesList();
  }, [user, language]);

  const onSubmit = async (formData) => {
    if (handleValidation()) {
      const newFormData = {
        ...formData,
        contact_person_id: contactPerson,
      };
      try {
        setLoading(true);
        const response = await HQBranchesApi.createHqBranch(newFormData);
        if (response.code === 200) {
          toast.success(t("hqbranch_created"));
          navigate("/org-structure");
        }
        if (response.code === 100 || response.code === 204) {
          toast.error(response.message);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <ManageHqBranchesWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("add_hq_branch")}
            onClick={() => navigate("/org-structure")}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <ContentWrapper>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="pt-4">
            <Box className="d-flex align-items-center flex-wrap px-4">
              <Box className="form-label">
                <LabelStyled size="15px" color="var(--text)">
                  {t("type")}*
                </LabelStyled>
              </Box>
              <Box>
                <Box className="d-flex align-items-center flex-wrap">
                  <Box>
                    <FormRadio
                      name={"location_type"}
                      label={t("headquarter")}
                      value={1}
                      register={register}
                      validationRules={{
                        required: true,
                      }}
                    />
                  </Box>
                  <Box>
                    <FormRadio
                      name={"location_type"}
                      label={t("branch")}
                      value={2}
                      register={register}
                      validationRules={{
                        required: true,
                      }}
                    />
                  </Box>
                </Box>

                {errors.location_type?.type === "required" && (
                  <ValidationErrorText
                    text={
                      t(errors.location_type?.message) || t("Pleaseselectone")
                    }
                  />
                )}
              </Box>
            </Box>
            <Box>
              <ValidatedInput
                name={"name_en"}
                label={t("name_en")}
                placeholder={t("english_name")}
                className={"border-0"}
                staric={true}
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
              />
              <ValidatedInput
                name={"name_ar"}
                label={t("name_ar")}
                placeholder={t("arabic_name")}
                className={"border-0"}
                staric={true}
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
              />
              <ValidatedInput
                name={"initial_name"}
                label={t("initial_name")}
                placeholder={t("initial_name")}
                className={"border-0"}
                // staric={true}
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                }}
              />
            </Box>
          </Box>
          <Box className="mt-4">
            <SpanStyled
              size={"20px"}
              weight="800"
              color="var(--text)"
              className="px-4"
            >
              {t("location")}
            </SpanStyled>
            <Box className="d-flex align-items-center px-4 hqbranch-form-item py-4 formEleContainer">
              <Box className="form-label">
                <LabelStyled size="15px" color="var(--text)">
                  {t("City")}
                </LabelStyled>
              </Box>
              <Box className="w-100">
                <LazyLoadDropdown
                  name="city_id"
                  control={control}
                  label={t("name_en")}
                  placeholder={t("select_city")}
                  options={cities}
                  filteredOptions={filteredCities}
                  loading={citiesLoading}
                  hasMore={hasMore}
                  onSearch={handleSearch}
                  onLoadMore={handleLoadMore}
                  validationRules={{ required: false }}
                />
                {/* <SelectionDropdown
                  name={"city"}
                  label={t("name_en")}
                  placeholder={t("select_city")}
                  onLoadMore={() => getCitiesList(currentPage + 1)}
                  hasMore={hasMore}
                  loading={citiesLoading}
                  options={cities}
                  register={register}
                  validationRules={{
                    required: true,
                  }}
                />
                {errors.city?.type === "required" && (
                  <ValidationErrorText
                    text={t(errors.city?.message) || t("Pleaseselectone")}
                  />
                )} */}
              </Box>
            </Box>
            <ValidatedInput
              name={"building"}
              label={t("building")}
              placeholder={t("building")}
              className={"border-0"}
              // staric={true}
              register={register}
              errors={errors}
              validationRules={{
                required: false,
              }}
            />
            <ValidatedInput
              name={"floor"}
              label={t("floor")}
              placeholder={t("floor")}
              className={"border-0"}
              // staric={true}
              register={register}
              errors={errors}
              validationRules={{
                required: false,
              }}
            />
            <ValidatedInput
              name={"office"}
              label={t("office")}
              placeholder={t("office")}
              className={"border-0"}
              // staric={true}
              register={register}
              errors={errors}
              validationRules={{
                required: false,
              }}
            />
            <ValidatedInput
              name={"address"}
              label={t("address")}
              placeholder={t("address")}
              className={"border-0"}
              // staric={true}
              register={register}
              errors={errors}
              validationRules={{
                required: false,
              }}
            />
          </Box>
          <Box className="mt-4">
            <SpanStyled
              size={"20px"}
              weight="800"
              color="var(--text)"
              className="px-4"
            >
              {t("contact")}
            </SpanStyled>

            <PhoneInputField
              name="contact_no"
              label={"contact_no"}
              placeholder={"contact_no"}
              className={"border-0"}
              // staric={true}
              register={register}
              control={control}
              errors={errors}
              validationRules={{
                required: false,
              }}
            />
            <ValidatedInput
              name={"email"}
              label={t("email")}
              type={"input"}
              fieldType={"email"}
              placeholder={t("emailPlaceholder")}
              className={"border-0"}
              // staric={true}
              register={register}
              errors={errors}
              validationRules={{
                required: false,
              }}
            />
            <Box className="d-flex align-items-center px-4 hqbranch-form-item py-4 formEleContainer">
              <Box className="form-label">
                <LabelStyled size="15px" color="var(--text)">
                  {t("contact_person")}
                </LabelStyled>
              </Box>
              <Box>
                <AddSingleUser
                  title={t("add_contact_person")}
                  icon={<Plus />}
                  mainParents={usersListWithAdminDir}
                  selPlaceholder={t("add_contact_person")}
                  setSelectedItem={setContactPerson}
                />
                {formErrors && formErrors.contactPerson && (
                  <ValidationErrorText text={t(formErrors.contactPerson)} />
                )}
              </Box>
            </Box>

            {/* <ValidatedInput
              name={"no_of_departments"}
              label={t("no_of_departments")}
              type={"input"}
              fieldType={"text"}
              placeholder={t("no_of_departments")}
              className={"border-0"}
              staric={true}
              register={register}
              errors={errors}
              validationRules={{
                required: true,
              }}
            /> */}
          </Box>
          <Box className="d-flex justify-content-end gap-3 p-4">
            <ButtonStyled
              label={t("Cancel")}
              bg={"var(--bgSecondary)"}
              color={"var(--text)"}
              type="button"
              onClick={() => navigate("/org-structure")}
            />
            <ButtonStyled
              label={t("Create")}
              bg={"var(--themeColor)"}
              isLoading={loading}
              type="submit"
            />
          </Box>
        </Form>
      </ContentWrapper>
    </ManageHqBranchesWrapper>
  );
};

export default AddHQBranch;
